import React from 'react';
import { GridColDef, GridRowSelectionModel } from '@mui/x-data-grid';
import { Box, Chip } from '@mui/material';

import { FGrid, FGridMoneyCell } from '../grid';
import { IAllocationActivity } from './budgetallocation.models';

type Props = {
  rows: IAllocationActivity[];
  selection: GridRowSelectionModel;
  loading?: boolean;
  onSelectionChange: (selection: GridRowSelectionModel) => void;
};

const statusColor = (status?: string): any => {
  switch ((status || '').toUpperCase()) {
    case 'ALLOCATED':
      return 'success';
    case 'RATIO_ONLY':
      return 'info';
    case 'UNALLOCATED':
      return 'warning';
    default:
      return 'default';
  }
};

class BudgetAllocationActivityGrid extends React.Component<Props> {
  columns: GridColDef[] = [
    { field: 'shortcode', headerName: 'Activity Code', width: 150 },
    { field: 'recname', headerName: 'Approved Programme Activity', flex: 1, minWidth: 320 },
    { field: 'costcenter_code', headerName: 'CC', width: 110 },
    { field: 'driver_count', headerName: 'Drivers', width: 95, type: 'number' },
    { field: 'allocation_count', headerName: 'Links', width: 90, type: 'number' },
    { field: 'allocated_amount', headerName: 'Allocated', width: 140, renderCell: FGridMoneyCell },
    {
      field: 'allocation_status',
      headerName: 'Status',
      width: 135,
      renderCell: (params) => (
        <Chip
          size="small"
          label={params.value || 'UNALLOCATED'}
          color={statusColor(params.value)}
        />
      ),
    },
  ];

  render() {
    return (
      <Box>
        <FGrid
          title="Eligible Activities"
          subtitle="Only programme-compliant activities should appear here."
          rows={this.props.rows || []}
          columns={this.columns}
          loading={this.props.loading}
          height={520}
          showQuickFilter
          toolbarSx={{ backgroundColor: '#eaf2fb' }}
          getRowId={(row: any) => row.recid || row.id}
          checkboxSelection
          rowSelectionModel={this.props.selection}
          onRowSelectionModelChange={this.props.onSelectionChange}
          pageSizeOptions={[25, 50, 100]}
          initialState={{
            pagination: { paginationModel: { pageSize: 25 } },
          }}
        />
      </Box>
    );
  }
}

export default BudgetAllocationActivityGrid;
